import { authFetch } from "./util";
import { ImageEntry } from "../models";

export async function uploadImage(b64Data: string): Promise<ImageEntry> {
  return authFetch("POST", `/api/images`, {"image": b64Data});
}
